(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/regenerator", "@babel/runtime/helpers/toConsumableArray", "@babel/runtime/helpers/asyncToGenerator", "@babel/runtime/helpers/classCallCheck", "@babel/runtime/helpers/createClass", "@babel/runtime/helpers/defineProperty", "../request", "./embeddedMessageProcessor", "./consts", "../constants", "../events/embedded/events", "./utils"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/regenerator"), require("@babel/runtime/helpers/toConsumableArray"), require("@babel/runtime/helpers/asyncToGenerator"), require("@babel/runtime/helpers/classCallCheck"), require("@babel/runtime/helpers/createClass"), require("@babel/runtime/helpers/defineProperty"), require("../request"), require("./embeddedMessageProcessor"), require("./consts"), require("../constants"), require("../events/embedded/events"), require("./utils"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.regenerator, global.toConsumableArray, global.asyncToGenerator, global.classCallCheck, global.createClass, global.defineProperty, global.request, global.embeddedMessageProcessor, global.consts, global.constants, global.events, global.utils);
    global.embeddedManager = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _regenerator, _toConsumableArray2, _asyncToGenerator2, _classCallCheck2, _createClass2, _defineProperty2, _request, _embeddedMessageProcessor, _consts, _constants, _events, _utils) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.IterableEmbeddedManager = void 0;
  _regenerator = _interopRequireDefault(_regenerator);
  _toConsumableArray2 = _interopRequireDefault(_toConsumableArray2);
  _asyncToGenerator2 = _interopRequireDefault(_asyncToGenerator2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  /* eslint-disable class-methods-use-this */
  var IterableEmbeddedManager = _exports.IterableEmbeddedManager = /*#__PURE__*/function () {
    function IterableEmbeddedManager(appPackageName) {
      (0, _classCallCheck2["default"])(this, IterableEmbeddedManager);
      (0, _defineProperty2["default"])(this, "appPackageName", void 0);
      (0, _defineProperty2["default"])(this, "messages", []);
      (0, _defineProperty2["default"])(this, "updateListeners", []);
      this.appPackageName = appPackageName;
    }
    (0, _createClass2["default"])(IterableEmbeddedManager, [{
      key: "syncMessages",
      value: function () {
        var _syncMessages = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(packageName, callback, placementIds) {
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.retrieveEmbeddedMessages(packageName, placementIds || []);
              case 2:
                callback();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function syncMessages(_x, _x2, _x3) {
          return _syncMessages.apply(this, arguments);
        }
        return syncMessages;
      }()
    }, {
      key: "retrieveEmbeddedMessages",
      value: function () {
        var _retrieveEmbeddedMessages = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(packageName, placementIds) {
          var _iterableResult$data, iterableResult, embeddedMessages, _iterableResult$data2, _iterableResult$data3, processor, _error$response, msg;
          return _regenerator["default"].wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return (0, _request.baseIterableRequest)({
                  method: 'GET',
                  url: _constants.ENDPOINTS.get_embedded_messages.route,
                  params: {
                    placementIds: placementIds,
                    platform: _constants.WEB_PLATFORM,
                    sdkVersion: _constants.SDK_VERSION,
                    packageName: packageName
                  }
                });
              case 3:
                iterableResult = _context2.sent;
                embeddedMessages = this.getEmbeddedMessages((iterableResult === null || iterableResult === void 0 ? void 0 : (_iterableResult$data = iterableResult.data) === null || _iterableResult$data === void 0 ? void 0 : _iterableResult$data.placements) || []);
                if (!embeddedMessages.length) {
                  _context2.next = 11;
                  break;
                }
                processor = new _embeddedMessageProcessor.EmbeddedMessagingProcessor((0, _toConsumableArray2["default"])(this.messages), this.getEmbeddedMessages(iterableResult === null || iterableResult === void 0 ? void 0 : (_iterableResult$data2 = iterableResult.data) === null || _iterableResult$data2 === void 0 ? void 0 : _iterableResult$data2.placements));
                this.setMessages(processor);
                _context2.next = 10;
                return this.trackNewlyRetrieved(processor);
              case 10:
                this.messages = (0, _toConsumableArray2["default"])(this.getEmbeddedMessages(iterableResult === null || iterableResult === void 0 ? void 0 : (_iterableResult$data3 = iterableResult.data) === null || _iterableResult$data3 === void 0 ? void 0 : _iterableResult$data3.placements));
              case 11:
                _context2.next = 16;
                break;
              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](0);
                if (_context2.t0 !== null && _context2.t0 !== void 0 && (_error$response = _context2.t0.response) !== null && _error$response !== void 0 && _error$response.data) {
                  msg = _context2.t0.response.data.msg;
                  if (msg.toLowerCase() === _consts.ErrorMessage.invalid_api_key.toLowerCase() || msg.toLowerCase() === _consts.ErrorMessage.subscription_inactive.toLowerCase()) {
                    this.notifyDelegatesOfInvalidApiKeyOrSyncStop();
                  }
                }
              case 16:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this, [[0, 13]]);
        }));
        function retrieveEmbeddedMessages(_x4, _x5) {
          return _retrieveEmbeddedMessages.apply(this, arguments);
        }
        return retrieveEmbeddedMessages;
      }()
    }, {
      key: "getEmbeddedMessages",
      value: function getEmbeddedMessages(placements) {
        var messages = [];
        placements.forEach(function (placement) {
          messages = [].concat((0, _toConsumableArray2["default"])(messages), (0, _toConsumableArray2["default"])(placement.embeddedMessages));
        });
        return messages;
      }
    }, {
      key: "setMessages",
      value: function setMessages(_processor) {
        this.messages = _processor.processedMessagesList();
      }
    }, {
      key: "getMessages",
      value: function getMessages() {
        return this.messages;
      }
    }, {
      key: "getMessagesForPlacement",
      value: function getMessagesForPlacement(placementId) {
        return this.messages.filter(function (message) {
          return message.metadata.placementId === placementId;
        });
      }
    }, {
      key: "trackNewlyRetrieved",
      value: function () {
        var _trackNewlyRetrieved = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(_processor) {
          var _this = this;
          var msgsList;
          return _regenerator["default"].wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                msgsList = _processor.newlyRetrievedMessages();
                this.notifyUpdateDelegates();
                msgsList.forEach( /*#__PURE__*/function () {
                  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(msg) {
                    return _regenerator["default"].wrap(function _callee3$(_context3) {
                      while (1) switch (_context3.prev = _context3.next) {
                        case 0:
                          return _context3.abrupt("return", (0, _events.trackEmbeddedReceived)(msg.metadata.messageId, _this.appPackageName));
                        case 1:
                        case "end":
                          return _context3.stop();
                      }
                    }, _callee3);
                  }));
                  return function (_x7) {
                    return _ref.apply(this, arguments);
                  };
                }());
              case 3:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this);
        }));
        function trackNewlyRetrieved(_x6) {
          return _trackNewlyRetrieved.apply(this, arguments);
        }
        return trackNewlyRetrieved;
      }()
    }, {
      key: "addUpdateListener",
      value: function addUpdateListener(updateListener) {
        this.updateListeners.push(updateListener);
      }
    }, {
      key: "notifyUpdateDelegates",
      value: function notifyUpdateDelegates() {
        this.updateListeners.forEach(function (updateListener) {
          updateListener.onMessagesUpdated();
        });
      }
    }, {
      key: "notifyDelegatesOfInvalidApiKeyOrSyncStop",
      value: function notifyDelegatesOfInvalidApiKeyOrSyncStop() {
        this.updateListeners.forEach(function (updateListener) {
          updateListener.onEmbeddedMessagingDisabled();
        });
      }

      // Get the list of updateHandlers
    }, {
      key: "getUpdateHandlers",
      value: function getUpdateHandlers() {
        return this.updateListeners;
      }
    }, {
      key: "click",
      value: function click(clickedUrl) {
        (0, _utils.handleEmbeddedClick)(clickedUrl);
      }
    }]);
    return IterableEmbeddedManager;
  }();
});